import React, {useState} from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import {useHistory} from 'react-router-dom';
import PasswordField from '../components/material-ui/PasswordField';
import medicLogo from '../assets/main-logo.svg';
import ButtonWithLoader from '../components/material-ui/ButtonWithLoader';
import {loginClient} from '../api';
import {useAppState} from '../app/AppState';
import {RoutesPaths} from '../environment';
import bkgrnd from '../assets/bkgrnd.jpeg';
import {pathToFileURL} from "url";
import { ThemeProvider } from '@material-ui/core';
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";



const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
 //   backgroundImage: "url(."+bkgrnd+")",
  },

  formContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    maxWidth: 520,
    width: '100%',
    '& > *': {
      marginTop: 10,
    },
  },
  formContainerTitle: {
    color: '#666',
    fontSize: 36,
    letterSpacing: 1,
    marginBottom: 15,
    display: 'flex',
    justifyContent: 'center'
  },
  logo: {
    height: 70,
    marginBottom: 26,
    marginTop: -80
  },
  errorText: {
    color: '#cc0000',
    fontSize: 14,
    height: 30,
  }
});


const AuthenticationPage = () => {
  const cl = useStyles();
  const history = useHistory();
  const appState = useAppState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [state, setState] = useState({
    login: '',
    password: '',
  });

  const onPressEnter = (e: React.KeyboardEvent) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    handleLogin();
  };

  const updateState = (key: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setError(false);
    setState(prev => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleLogin = () => (async () => {
    setLoading(true);
    const result = await loginClient(state.login, state.password);

    if (result instanceof Error) {
      setError(true);
      setLoading(false);
      return;
    }

    appState.client[1](result);
    history.push(RoutesPaths.LandingPage);
    setLoading(false);
  })();


  const theme = createMuiTheme({
    palette: {
      primary:  {
        50: '#2cb8ac',
        100: '#2cb8ac',
        200: '#2cb8ac',
        300: '#2cb8ac',
        400: '#2cb8ac',
        500: '#00aca1',
        600: '#2cb8ac',
        700: '#2cb8ac',
        800: '#2cb8ac',
        900: '#2cb8ac',
        A100: '#2cb8ac',
        A200: '#2cb8ac',
        A400: '#2cb8ac',
        A700: '#2cb8ac'
      },
    },
 /*   overrides: {
      MuiTextField: {
    //    MuiOutlinedInput: {
          borderColor : '#2cb8ac',
  //      },
      },
    },*/
    overrides: {
      MuiOutlinedInput: {
        notchedOutline: {
          borderColor: '#2cb8ac',
        },
        root: {
          '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
            borderColor: '#f50057',
          },
        },
      },
      MuiInputLabel: {
        outlined:{
          color: '#2cb8ac',
          fontWeight: 'bold',
        },
        shrink:{
          color: '#f50057',
        }
      } ,
    }
  });


  return (
    <div className={cl.root} >
      <div className={cl.formContainer}>
        <img className={cl.logo} src={'/auth/' + medicLogo} alt="Біокурс"/>
        <div className={cl.formContainerTitle}>Авторизація</div>
        <ThemeProvider theme={theme}>
        <TextField
          error={error}
          onKeyPress={onPressEnter}
          disabled={loading}
          label="Логін"
          variant="outlined"
          value={state.login}
          onChange={updateState('login')}
        />
        <PasswordField
          error={error}
          onKeyPress={onPressEnter}
          disabled={loading}
          variant="outlined"
          label="Пароль"
          value={state.password}
          onChange={updateState('password')}
        />
        <ButtonWithLoader
          onClick={handleLogin}
          variant="contained"
          size="large"
          color="primary"
          loading={loading}
        >
          Увійти
        </ButtonWithLoader>
        <p className={cl.errorText}>{error && 'Неправильний логін або пароль!'}</p>
        </ThemeProvider>
      </div>
    </div>
  );
};

export default AuthenticationPage;
